import { z } from "zod";

import { CoverPageDocumentType } from "@/src/models/constants/document-types";
import { DatabaseDefaults } from "@/src/models/database-defaults";
import { Patient, patientSchema } from "@/src/models/patient";

export const coverPageTypeDisplay: Record<CoverPageDocumentType, string> = {
  [CoverPageDocumentType.COVER_PAGE]: "Cover Page",
};

export const coverPageSchema = z.object({
  patient: patientSchema,
});

export type CoverPage = Omit<z.infer<typeof coverPageSchema>, "patient"> & {
  patient: Patient | null;
} & DatabaseDefaults;

export const coverPageShape: CoverPage = {
  id: "",
  patient: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
};
